"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_advanced_user_details = void 0;
var firestore_1 = require("firebase/firestore");
var firebase_1 = require("../../../firebase");
var store_1 = require("../../../store");
var functions_1 = require("../../../constants/functions");
var firebase_collections_1 = require("../../../constants/firebase_collections");
function update_advanced_user_details(request) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var state, userState, userDocRef, updateData, userDocSnapshot, userProfile, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    state = store_1.redux_store.getState();
                    userState = state.userState;
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.USERS, "".concat(userState.user.uid))];
                case 1:
                    userDocRef = _b.sent();
                    updateData = {};
                    //Check null value in the request
                    request = (0, functions_1.removeUndefinedProperties)(request);
                    if (request.friend)
                        updateData["friend"] = request.friend;
                    if (request.paypoint_details)
                        updateData["paypoint_details"] = request.paypoint_details;
                    if (request.employment_details)
                        updateData["employment_details"] = request.employment_details;
                    if (request.family_member)
                        updateData["family_member"] = request.family_member;
                    if (request.salary_bank)
                        updateData["salary_bank"] = request.salary_bank;
                    if (request.spouse)
                        updateData["spouse"] = request.spouse;
                    if (request.gender)
                        updateData["gender"] = request.gender;
                    if (request.marriage_type)
                        updateData["marriage_type"] = request.marriage_type;
                    if (request.is_married)
                        updateData["is_married"] = (_a = request.is_married) !== null && _a !== void 0 ? _a : false;
                    if (request.postal_address)
                        updateData["postal_address"] = request.postal_address;
                    if (request.home_address)
                        updateData["home_address"] = request.home_address;
                    if (request.id_number)
                        updateData["id_number"] = request.id_number;
                    if (request.financial_detail)
                        updateData["financial_detail"] = request.financial_detail;
                    // Update Firebase Doc
                    (0, firestore_1.updateDoc)(userDocRef, updateData);
                    return [4 /*yield*/, (0, firestore_1.getDoc)(userDocRef)];
                case 2:
                    userDocSnapshot = _b.sent();
                    if (userDocSnapshot.exists()) {
                        userProfile = userDocSnapshot.data();
                        return [2 /*return*/, { success: true, message: "Data Saved", content: __assign({ is_loading: false }, userProfile) }];
                    }
                    else {
                        return [2 /*return*/, { success: false, message: "User profile not found", content: null }];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error("error", error_1);
                    return [2 /*return*/, { success: true, message: null, content: null }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.update_advanced_user_details = update_advanced_user_details;
